/**
 * Drop comparison-table rows that don't belong to the current prediction.
 *
 * A Quick Valuation hydrate seeds the comparison table from the active
 * prediction's `similar_properties`. The transaction store is a shared Pinia
 * singleton, so rows left over from a previous module (e.g. an Evaluation of
 * the SAME address opened just before) survive into the QV run unless dropped.
 * The web result renders the prediction props directly (always correct), but
 * the short-report export reads the store — so a leftover row produced a 6-row
 * DOCX while the web showed 3 at the COOP demo (2026-06-15).
 *
 * Keeping rows whose id IS in the prediction (rather than clearing everything)
 * avoids a redundant detail/buildings refetch when the same prediction is
 * re-hydrated — e.g. when Inertia deferred props arrive after the initial
 * render and the hydrate watcher fires again.
 *
 * @param {Array<{id: number|string}>} rows           current selectionTableRows
 * @param {Array<number|string>} predictedIds          property_id of each comparable
 * @returns {Array} rows belonging to the prediction, original order preserved
 */
export function pruneStaleComparables(rows, predictedIds) {
  if (!Array.isArray(rows)) {
    return []
  }

  const keep = new Set((predictedIds ?? []).map(id => Number(id)))

  return rows.filter(row => keep.has(Number(row?.id)))
}
